import { Component, OnInit } from '@angular/core';
import { QbeIcons } from 'qbe-components';
import { ConclusionType } from '../../model/conclusion-type.model';
import { RadioButton } from '../../component/radio-buttons/radio-buttons.component';
import * as fromProcess from '../../store/process/process.reducer';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { ProcessService } from '../../services/process.service';
import { ApiState } from 'src/app/model/api-state.model';
import { environment } from 'src/app/environments/environment';

interface HorizontalButton extends RadioButton {
  value: ConclusionType;
}

@Component({
  selector: 'app-page-conclusion',
  templateUrl: './conclusion.component.html',
  styleUrls: ['./conclusion.component.scss'],
})
export class ConclusionComponent implements OnInit {
  horizontalButtons: HorizontalButton[] = [
    {
      label: 'conclusion.kind.agent',
      qbeIcon: QbeIcons.Person,
      value: ConclusionType.Agent,
    },
    {
      label: 'conclusion.kind.remote',
      qbeIcon: QbeIcons.Laptop,
      value: ConclusionType.Remote,
    },
  ];

  apiState = ApiState;
  globtroterApp = environment.globtroterApp;
  conclusion$: Observable<ConclusionType | null> = this.store.select(fromProcess.selectProcessConclusion);
  currentStep$ = this.store.select(fromProcess.selectProcessStep);
  selectProcessSavedOfferState$ = this.store.select(fromProcess.selectProcessSavedOfferState);
  selectProcessSavedOfferError$ = this.store.select(fromProcess.selectProcessSavedOfferError);
  selectProcessSavedOfferPolicyNumber$ = this.store.select(fromProcess.selectProcessSavedOfferPolicyNumber);
  ngDestroy$ = new Subject<void>();

  constructor(private store: Store<AppState>, private processService: ProcessService) {
    this.currentStep$.pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.store.dispatch(fromProcess.actions.saveOfferCalculationReset());
    });
  }

  ngOnInit(): void {
    this.store.dispatch(fromProcess.actions.setStep({ step: 6 }));
    this.processService.onPageInit();
  }

  handleChange(data: RadioButton) {
    this.store.dispatch(fromProcess.actions.setConclusion({ conclusion: data.value as ConclusionType }));
  }
}
